module.exports = __webpack_public_path__ + "static/img/rightIcon.9e6277d8.png";